(ns basic-components.inputs.date
  (:require
   [basic-components.inputs.footprint :refer [editor viewer display-string]]
   [reagent.core :as r]
   [common.dates :as dates]
   [common.localization :as loc]
   [reagent.dom :as rd]
   [ui.components.date-picker.view :as date-picker]
   [common.date-formats :as date-formats]
   [frontend.state.current-session :as session]
   [common.timezones :as timezones]))

(defn render
  [dom-atom args]
  (let [{:keys [value class-name
                has-focus? min-date
                on-focus! on-blur! on-change! full-width?
                on-key-down! disabled? field/not-clearable?
                on-error! clear-error! theme
                open-on-start? position on-open on-close]}
        args

        value (or (:temp-value @dom-atom) value)
        edit-value (or (:temp-value @dom-atom) value)
        date-pattern (or (:tenant/date-format @session/tenant)
                         (loc/tr :date-format))
        dt-val (cond (nil? edit-value) nil
                     (number? edit-value) (js/Date. edit-value)
                     (and (string? edit-value)
                          (not= edit-value ""))
                     (dates/date edit-value {:pattern "yyyy/MM/dd"}))
        ms-val (when dt-val (.getTime dt-val))
        js-dt (when ms-val (js/Date. ms-val))
        plc-value (if js-dt
                    (dates/format dt-val
                                  {:pattern date-pattern})
                    (loc/tr :date-select-text))]
    [date-picker/view
     {:value           ms-val
      :on-change       (fn [utc-ms]
                         (let [value (or utc-ms "")]
                           (on-change! nil value)
                           (when (fn? on-blur!)
                             (on-blur! nil value))
                           (when (fn? on-close)
                             (on-close))))
      :on-focus        (fn [e]
                         (when (fn? on-focus!)
                           (on-focus! e)))
      :on-error!       on-error!
      :clear-error!    clear-error!
      :on-open         on-open
      :min-date        (when min-date
                         (js/Date. min-date))
      :placeholder     plc-value
      :variant         :underline
      :transparent? true
      :full-width?     full-width?
      :open-on-start?  open-on-start?
      :not-clearable?  not-clearable?
      :date-format     date-pattern}]))


(defmethod editor :editor.type/date
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)

        set-save! (:set-save! args)] ;; when do we reset the state ?
    ;; ref vs atom
    (r/create-class
     {:display-name           "Date"
      :component-did-mount    (fn [args]
                                (let []
                                  ;; we use this to know where focus is changing - we can prevent blur if focus is changing to
                                  ;; events withing this editor if needed
                                  (when set-focusable!
                                    (set-focusable! (fn [_]
                                                      (when-let [dom-node (:input-dom-node @dom-atom)]
                                                        (.focus dom-node)))))
                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [_]
                                                        (swap! dom-atom dissoc :temp-value)))) ;; save complete -> reset temp state
                                  (when set-save!
                                    (set-save! (fn [_]
                                                 (when-let [dom-node (:input-dom-node @dom-atom)]
                                                   (.blur dom-node)))))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [args]
                                (render dom-atom args))})))

(defn ms->tenant-date
  [value]
  (when-not (or (nil? value) (= value 0))
    (date-formats/format-millis value
                                (or (:tenant/date-format @session/tenant) (loc/tr :date-format))
                                (or (:tenant/timezone @session/tenant)
                                    timezones/default-timezone))))

(defmethod display-string :editor.type/date
  [args]
  (ms->tenant-date (:value args)))

(defmethod viewer :editor.type/date
  [args]
  (r/create-class
   {:display-name   "Date/viewer"
    :reagent-render (fn [args]
                      [:div.preview.preview-date.h-10.flex.items-center
                       (display-string args)])}))
